import { useState } from "react";
import useModal, { MODAL_LG, MODAL_md } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { CreateUBLInvoice } from "./CreateUBLInvoice";
import { toast } from "react-toastify";
import { CardTaps } from "../../../../../theme/Component/CardTaps";
import { ImportUBLInvoice } from "../ImportUBLInvoice";

interface Props {
    data: any;
    label?: string;
    renderValue: string | null;
    onChange: Function;
}
export const CreateUBLInvoiceEditor = ({ data, label, renderValue, onChange }: Props) => {

    const modal = useModal("Factura", MODAL_LG);
    const [ubl, setUbl] = useState<any>({});
    const [lab, setLab] = useState<any>(renderValue ?? '');

    const returnUBL = () => {
        const factura = {
            DataBeanProperties: ubl,
            DataBeanName: 'com.quickdataerp.bean.ubl.UBLInvoice'
        }
        if (ubl.IDUBLInvoice) {
            onChange(factura);
            setLab(ubl.AccountCustomerName);
            modal.close();
        } else {
            toast.warning("No ha seleccionado una factura");
        }


    }
    let taps = [
        { id: 0, name: 'Importar Factura', disable: false },
        { id: 1, name: 'Crear Factura', disable: false }
    ];

    const [indexTap, setIndexTap] = useState(0);

    return (
        <div className="row">
            <div className="col-md-12">
                <label>{label ?? 'Factura'}</label>
                <input type="text" placeholder={lab ?? ''} className="form-control cursor" onClick={() => { modal.open() }} />
            </div>
            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={returnUBL} onSubmitLabel="Seleccionar" >
                    <CardTaps taps={taps} index={indexTap} updateIndex={setIndexTap} >
                        <>
                            {indexTap === 0 ?
                                <ImportUBLInvoice _onChange2={setUbl} entry={"Accounting"} />
                                :
                                <CreateUBLInvoice typeDocument="Supplier" _idAccount={data.IDAccount} _onChange2={setUbl} />
                            }
                        </>
                    </CardTaps>
                </Modal>
            </div>
        </div>
    )
}